export default {
  API_URL: "https://api.rmc.ai/",
  PROJECT_DASHBOARD_API_URL: "https://api.rmc.ai/",
  //API_URL: "http://rmc-api-alb2-1174504429.us-west-2.elb.amazonaws.com/",
  //PROJECT_DASHBOARD_API_URL: "http://rmc-api-alb2-1174504429.us-west-2.elb.amazonaws.com/",
  //API_URL: "http://localhost:5000/",
  //PROJECT_DASHBOARD_API_URL: "http://localhost:5000/",
  DEFAULT_PAGE_SIZE: 1000,
  DEBUG: 0,
  ROLE: { admin: "ROLE_ADMIN", user: "ROLE_USER" },
  PLATFORM_ROLE: { admin: "PLATFORM_ADMIN", user: "PLATFORM_USER", none: "NONE" },
  IOT_ROLE: { admin: "IOT_ADMIN", user: "IOT_USER", none: "NONE" }
};



// WEBPACK FOOTER //
// ./src/config/constants.js